@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="pricing-grid stagger">
      @for (card of s.items; track card.label) {
        <article
          class="pricing-card"
          [class.pricing-card--highlight]="card.highlight"
        >
          <div class="pricing-card__icon-wrap">
            <mat-icon>{{ card.icon }}</mat-icon>
          </div>
          <span class="pricing-card__label">{{ card.label }}</span>
          <p class="pricing-card__price">{{ card.price }}</p>
          <p class="pricing-card__desc">{{ card.description }}</p>
        </article>
      }
    </div>
  </app-section-wrapper>
}
